import React from "react"

function Demo() {
  return <div>This is from fajnyczas-web</div>
}

export default Demo
